var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancelBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1605_13450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1605_13450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 11.167L12.416 13.5837C12.5688 13.7364 12.7632 13.8128 12.9993 13.8128C13.2355 13.8128 13.4299 13.7364 13.5827 13.5837C13.7355 13.4309 13.8118 13.2364 13.8118 13.0003C13.8118 12.7642 13.7355 12.5698 13.5827 12.417L11.166 10.0003L13.5827 7.58366C13.7355 7.43088 13.8118 7.23644 13.8118 7.00033C13.8118 6.76421 13.7355 6.56977 13.5827 6.41699C13.4299 6.26421 13.2355 6.18783 12.9993 6.18783C12.7632 6.18783 12.5688 6.26421 12.416 6.41699L9.99935 8.83366L7.58268 6.41699C7.4299 6.26421 7.23546 6.18783 6.99935 6.18783C6.76324 6.18783 6.56879 6.26421 6.41602 6.41699C6.26324 6.56977 6.18685 6.76421 6.18685 7.00033C6.18685 7.23644 6.26324 7.43088 6.41602 7.58366L8.83268 10.0003L6.41602 12.417C6.26324 12.5698 6.18685 12.7642 6.18685 13.0003C6.18685 13.2364 6.26324 13.4309 6.41602 13.5837C6.56879 13.7364 6.76324 13.8128 6.99935 13.8128C7.23546 13.8128 7.4299 13.7364 7.58268 13.5837L9.99935 11.167ZM9.99935 18.3337C8.84657 18.3337 7.76324 18.1149 6.74935 17.6774C5.73546 17.2399 4.85352 16.6462 4.10352 15.8962C3.35352 15.1462 2.75977 14.2642 2.32227 13.2503C1.88477 12.2364 1.66602 11.1531 1.66602 10.0003C1.66602 8.84755 1.88477 7.76421 2.32227 6.75033C2.75977 5.73644 3.35352 4.85449 4.10352 4.10449C4.85352 3.35449 5.73546 2.76074 6.74935 2.32324C7.76324 1.88574 8.84657 1.66699 9.99935 1.66699C11.1521 1.66699 12.2355 1.88574 13.2493 2.32324C14.2632 2.76074 15.1452 3.35449 15.8952 4.10449C16.6452 4.85449 17.2389 5.73644 17.6764 6.75033C18.1139 7.76421 18.3327 8.84755 18.3327 10.0003C18.3327 11.1531 18.1139 12.2364 17.6764 13.2503C17.2389 14.2642 16.6452 15.1462 15.8952 15.8962C15.1452 16.6462 14.2632 17.2399 13.2493 17.6774C12.2355 18.1149 11.1521 18.3337 9.99935 18.3337Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancelBlue);
export default __webpack_public_path__ + "static/media/icon_cancel_blue.be61fca700f7a27ccbca59e9a4f7b23a.svg";
export { ForwardRef as ReactComponent };